import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="relative grid min-h-dvh grid-cols-[1fr_2.5rem_minmax(0,var(--container-lg))_2.5rem_1fr] grid-rows-[1fr_auto_1fr] overflow-clip">
      {/* Left stripe background */}
      <div className="col-start-2 row-span-full row-start-1 max-sm:hidden h-full w-full text-gray-950/[0.04] border-x border-x-current bg-[length:12px_12px] bg-fixed bg-[repeating-linear-gradient(-45deg,currentColor_0_1px,transparent_0_6px)] animate-stripes" />
      {/* Right stripe background */}
      <div className="col-start-4 row-span-full row-start-1 max-sm:hidden h-full w-full text-gray-950/[0.04] border-x border-x-current bg-[length:12px_12px] bg-fixed bg-[repeating-linear-gradient(-45deg,currentColor_0_1px,transparent_0_6px)] animate-stripes" />
      {/* Main content area with horizontal lines using before/after */}
      <main
        className="
          relative grid grid-cols-1
          max-sm:col-span-full max-sm:col-start-1 max-sm:row-span-full max-sm:bg-gray-950/5 max-sm:p-2
          sm:line-y sm:col-start-3 sm:row-start-2 sm:-mx-px sm:p-[calc(0.5rem+1px)]
          before:content-[''] before:absolute before:top-0 before:left-1/2 before:-translate-x-1/2 before:w-screen before:h-px before:bg-gray-200 before:z-10
          after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-screen after:h-px after:bg-gray-200 after:z-10
        "
      >
        <div className="grid grid-cols-1 items-center rounded-xl bg-white max-sm:p-6 sm:p-10">
          {children}
        </div>
      </main>
    </div>
  );
};
